import { useState } from "react"

import edit_img from '../../assets/images/edit.svg'

import { Form } from "react-bootstrap"

export default function EditableInput({value, className, style={}, required, placeholder='', type, onChange}) {

    const [enableEdit, setEnableEdit] = useState(false)

    const handleDisableEdit = (e) =>{
        if (e.key === 'Enter') {
            setEnableEdit(false)
        }
    }

    return (
        <>
            {
                enableEdit ?
                    <Form.Control onKeyDown={handleDisableEdit} className="auto-width" required={required} type={type || 'text'} value={value}  onChange={onChange} />
                : 
                <div className="d-flex" >
                    <span className={className} style={style}>{value || placeholder}</span>
                    <img src={edit_img} className="ms-2 pointer" onClick={()=>setEnableEdit(true)} />
                </div>
            }
        </>
    )
}